import http from "./http-common";
import Cookies from "js-cookie";

const login = (data) => {
  return http.post("api/User/PostingLogin", data).then((response) => {
    const token = response.data.jwtToken;
    if (token) {
      Cookies.set("jwtToken", response.data.jwtToken, { expires: 7, path: "/" });
      Cookies.set("controllerId", response.data.controllerId, { expires: 7, path: "/" });
      Cookies.set("controllerName", response.data.controllerName, { expires: 7, path: "/" });
      Cookies.set("department", response.data.department, { expires: 7, path: "/" });
      Cookies.set("posting", response.data.posting, { expires: 7, path: "/" });
      Cookies.set("username", response.data.username, { expires: 7, path: "/" });
      
    }

    return response.data;
  });
};

const logout = () => {
  localStorage.removeItem("user");
  localStorage.removeItem("token");
  localStorage.removeItem("startDate");
  localStorage.removeItem("endDate");
  localStorage.clear();
};

const getToken = () => {
  // return JSON.parse(localStorage.getItem("token"));
  return Cookies.get("token");

};

const getCurrentUser = () => {
  // return JSON.parse(localStorage.getItem("user"));
  const user = {
    jwtToken: Cookies.get("jwtToken") || null,
    controllerId: Cookies.get("controllerId") || null,
    controllerName: Cookies.get("controllerName") || null,
    department: Cookies.get("department") || null,
    posting: Cookies.get("posting") || null,
    username: Cookies.get("username") || null,
  };
  if (Object.values(user).some((val) => val !== null)) {
    return user;
  } else {
    // fallback to localStorage if no cookies found
    return JSON.parse(localStorage.getItem("user"));
  }
};

const AuthService = {
  login,
  logout,
  getToken,
  getCurrentUser,
};

export default AuthService;
